var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowMaximize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.75C12.5 2.33579 12.8358 2 13.25 2H21C21.5523 2 22 2.44772 22 3V10.75C22 11.1642 21.6642 11.5 21.25 11.5C20.8358 11.5 20.5 11.1642 20.5 10.75V4.56066L12.7803 12.2803C12.4874 12.5732 12.0126 12.5732 11.7197 12.2803C11.4268 11.9874 11.4268 11.5126 11.7197 11.2197L19.4393 3.5H13.25C12.8358 3.5 12.5 3.16421 12.5 2.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.841 13.341L19 8.18198V10.75C19 11.9926 20.0074 13 21.25 13C21.513 13 21.7654 12.9549 22 12.872V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H11.128C11.0451 2.23458 11 2.48702 11 2.75C11 3.99264 12.0074 5 13.25 5H15.818L10.659 10.159C9.78033 11.0377 9.78033 12.4623 10.659 13.341C11.5377 14.2197 12.9623 14.2197 13.841 13.341Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowMaximize);
export default __webpack_public_path__ + "static/media/window-maximize.f263d6c10483dc9b261ea47ef8cc36fd.svg";
export { ForwardRef as ReactComponent };